import { Contexts, getContainer, NamedBindings, SourceEventForList, UserService } from "@dandelion/core";
import axios from "axios";
import { toast } from "vue3-toastify";
import { injectable } from "inversify";

@injectable()
export class EventSynchStorage {

  protected SYNCH_BASE_URL = import.meta.env.VITE_APP_API_SYNCH_URL;
  protected userService: UserService;
  protected centreCode: string;

  constructor(
  ) {
    this.userService = getContainer(Contexts.SHARED).get(NamedBindings.UserService) as UserService;
    this.centreCode = this.userService.getCurrentUser()?.value?.centre || '*';
  }
  async loadAllEvents(): Promise<SourceEventForList[]> {

    let data = [];
    try {
      data = (
        await axios.get(this.SYNCH_BASE_URL +
          `/FindDocuments?CollectionName=NewDandelionProsafeEventsTest&condition={"centreCode":"${this.centreCode}"}&sorting={}&projection={}`)
      ).data;
    } catch (error: any) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        const responseHeadersHTML = `<details><summary>Response Headers</summary><dl>${formatHeadersAsHTML(
          error.response.headers
        )}</dl></details>`;
        const errorData = `<details><summary>Response Data</summary><dl>${formatData(
          error.response.data
        )}</dl></details>`;
        const errorString = error.message + '\n' + errorData + '\n' + responseHeadersHTML;
        console.log(errorString);
        setTimeout(
          () =>
            toast.error(errorString, {
              toastId:"syncherror",
              dangerouslyHTMLString: true,
              closeOnClick: false,
              autoClose: false,
            }),
          0
        );
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        if (error.request.response === '') {
          setTimeout(() => toast.error('Error: ' + error.message), 0);
        } else {
          setTimeout(() => toast.error(error.request), 0);
        }
      } else {
        // Something happened in setting up the request that triggered an Error
        setTimeout(() => toast.error('Error: ' + error.message), 0);
      }
      console.log(error.config);
    }
    const resultArray = Array.isArray(data) ? data : [];
    return resultArray.map(e => ({ ...e, timestamp: new Date(Number(e.timestamp.$date.$numberLong)) }));
  }

  async saveEvent(event: SourceEventForList): Promise<string> {
    try {
      await axios.post(encodeURI(this.SYNCH_BASE_URL + `/SetDocument?collectionName=NewDandelionProsafeEventsTest&condition={"caseID":"${event.caseID}","handler":"${event.handler}","centreCode":"${this.centreCode}"}`),
        { ...event, centreCode: this.centreCode });
    } catch (error: any) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        const responseHeadersHTML = `<details><summary>Response Headers</summary><dl>${formatHeadersAsHTML(
          error.response.headers
        )}</dl></details>`;
        const errorData = `<details><summary>Response Data</summary><dl>${formatData(
          error.response.data
        )}</dl></details>`;
        const errorString = error.message + '\n' + errorData + '\n' + responseHeadersHTML;
        console.log(errorString);
        setTimeout(
          () =>
            toast.error(errorString, {
              dangerouslyHTMLString: true,
              closeOnClick: false,
              autoClose: false,
            }),
          0
        );
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        if (error.request.response === '') {
          setTimeout(() => toast.error('Error: ' + error.message), 0);
        } else {
          setTimeout(() => toast.error(error.request), 0);
        }
      } else {
        // Something happened in setting up the request that triggered an Error
        setTimeout(() => toast.error('Error: ' + error.message), 0);
      }
      console.log(error.config);
    }
    // todo: verify if we need to handle error
    return event.id;
  }
}

function formatHeadersAsHTML(headers: any) {
  return Object.entries(headers)
    .map(([key, value]) => `${key}: ${value}`)
    .join('\n');
}

function formatData(data: any) {
  return Object.entries(data)
    .map(([key, value]) => `${key}: ${value}`)
    .join('\n');
}
